import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';

const STORAGE_KEY = 'datapro_language';
const DEFAULT_LANGUAGE = 'es';

// Read persisted language; fall back to Spanish (no browser auto-detection
// per product decision — box users are LATAM/ES-first by default).
const initialLanguage = (() => {
  try {
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (stored === 'es' || stored === 'en') return stored;
  } catch {
    // localStorage not available (e.g. SSR / privacy mode) — use default.
  }
  return DEFAULT_LANGUAGE;
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: { escapeValue: false },
    returnNull: false,
  });

// Persist language on every change so the topbar toggle survives reloads.
i18n.on('languageChanged', (lng) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.setAttribute('lang', lng);
  } catch {
    // Ignore storage errors — the in-memory value already switched.
  }
});

// Set initial <html lang="..."> for a11y / SEO.
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', initialLanguage);
}

export default i18n;
